 
<div class="card m-3"> 
  <div class="card-body">
    <h2>Add/Edit Distributor</h2>
    <form  [formGroup]="form" >
      <mat-form-field>
        <input matInput placeholder="Name" formControlName="name" required size="50">
      </mat-form-field>
      <button mat-raised-button color="primary" (click)="onSubmit()">Submit</button>
    </form>
  </div>
  
 
<div class="card m-3"> 
 
<br>
<br>
      <table class="table table-striped table-sm">
 
 
    <thead>
      <tr>
        <!-- <th>MaterialsID</th> -->
 
        <th><a (click)="sortBy('productName')">Product Name{{sortIcon('productName')}}</a></th>
        <th><a (click)="sortBy('productCategory')">Product Category{{sortIcon('productCategory')}}</a></th>
        <th><a (click)="sortBy('subCategory')">Sub Category{{sortIcon('subCategory')}}</a></th> 
        <th><a (click)="sortBy('productDescription')">Product Description{{sortIcon('productDescription')}}</a></th>
        <th><a (click)="sortBy('productPrice')">Product Price{{sortIcon('productPrice')}}</a></th>
        <th><a (click)="sortBy('productWeight')">Product Weight{{sortIcon('productWeight')}}</a></th>
        <th><a (click)="sortBy('units')">Units{{sortIcon('units')}}</a></th>
        <th><a (click)="sortBy('total')">Total{{sortIcon('total')}}</a></th>
        <th>Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let material of distributorMaterials">
        <!-- <td>{{ material.materialsID }}</td> -->
        <td>{{ material.productName }}</td>
        <td>{{ material.productCategory }}</td>
        <td>{{ material.subCategory }}</td> 
        <td>{{ material.productDescription }}</td>
        <td>{{ material.productPrice }}</td>
        <td>{{ material.productWeight }}</td>
        <td>{{ material.units }}</td>
        <td>{{ material.total }}</td>
        <td>
          <button (click)="removeMaterialfromDistributor(material)">Remove</button>
        </td>
      </tr>
    </tbody>
  </table>
  </div> 
 







  <button mat-button color="success" (click)="toggleAvailbleMaterials()">
  <mat-icon class="mr">menu</mat-icon>Add Additonal Materials
  </button>


<div class="card m-3" *ngIf="showAvailbleMaterials"> 
  <div class="card-body">

    <button mat-button color="success" (click)="addAllMaterials()">
<mat-icon class="mr">add</mat-icon>Add All Materials
</button>
<br>
<br>
      <table class="table table-striped table-sm">
 
 
    <thead>
      <tr>
        <!-- <th>MaterialsID</th> -->
 
        <th><a (click)="sortBy('productName')">Product Name{{sortIcon('productName')}}</a></th>
        <th><a (click)="sortBy('productCategory')">Product Category{{sortIcon('productCategory')}}</a></th>
        <th><a (click)="sortBy('subCategory')">Sub Category{{sortIcon('subCategory')}}</a></th> 
        <th><a (click)="sortBy('productDescription')">Product Description{{sortIcon('productDescription')}}</a></th>
        <th><a (click)="sortBy('productPrice')">Product Price{{sortIcon('productPrice')}}</a></th>
        <th><a (click)="sortBy('productWeight')">Product Weight{{sortIcon('productWeight')}}</a></th>
        <th><a (click)="sortBy('units')">Units{{sortIcon('units')}}</a></th>
        <th><a (click)="sortBy('total')">Total{{sortIcon('total')}}</a></th>
        <th>Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let material of materials">
        <!-- <td>{{ material.materialsID }}</td> -->
        <td>{{ material.productName }}</td>
        <td>{{ material.productCategory }}</td>
        <td>{{ material.subCategory }}</td> 
        <td>{{ material.productDescription }}</td>
        <td>{{ material.productPrice }}</td>
        <td>{{ material.productWeight }}</td>
        <td>{{ material.units }}</td>
        <td>{{ material.total }}</td>
        <td>
          <button (click)="addMaterialToDistributorMaterials(material)">Add</button>
        </td>
      </tr>
    </tbody>
  </table>
  </div></div>
 </div>